module.exports = __webpack_public_path__ + "img/strip_head_a+.9bcbc3bd.jpg";